import React from 'react';
import './SuccessBanner.css';

/**
 * SuccessBanner Component - Displays success message after actions
 *
 * @param {Object} props
 * @param {string} props.message - Success message to display
 * @param {string} [props.icon="✓"] - Icon to display
 * @param {string} [props.className=""] - Additional CSS classes
 */
function SuccessBanner({ message, icon = "✓", className = "" }) {
  return (
    <div className={`success-banner ${className}`}>
      <span className="success-icon">{icon}</span>
      <p>{message}</p>
    </div>
  );
}

export default SuccessBanner;
